<template>
  <div>
    <Form :model="searchItem"
          :label-width="85"
          label-position="left"
          :disabled="modal_loading"
          ref="formValidate"
          :show-message="false"
          style="margin-top:20px">
      <Row style="margin-bottom: 0">
        <Col span="5">
        <FormItem label="员工编码">
          <Input v-model="searchItem.empCode" />
        </FormItem>
        </Col>
        <Col span="5"
             offset="1">
        <FormItem label="员工姓名">
          <Input v-model="searchItem.cName" />
        </FormItem>
        </Col>
        <Col span="1"
             offset="1">
        <Button type="primary"
                @click="getData()"><!-- 检索 -->{{$t('Search')}}</Button>
        </Col>
      </Row>
    </Form>
    <Table style="margin-top: 20px;"
           border
           :columns="columns1"
           :loading="modal_loading"
           :data="dataTable">
      <template slot="slot1"
                slot-scope="{ row }">
        <div>
          <Icon @click="openPop(1,row)"
                type="md-eye"
                style="font-size: 30px;"
                color="rgb(33,181,245)"></Icon>
        </div>
      </template>
    </Table>
    <Page :total="this.totalNum" :disabled="modal_loading" class="Page-style" @on-change="pageChange" />
    <Button  class="Page-style-end" :disabled="modal_loading" @click="download">导出Excel</Button>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
  data () {
    return {
      date: new DateUtil(),
      searchItem: {
        empCode: '',
        cName: ''
      },
      modal_loading: false,
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10, //每页数据条数
      },
      columns1:[],
      columns2: [
        // {
        //     title: '员工编号',
        //     key: 'serialnumber',
        //     align: "center"
        // },
        // {
        //     title: '姓名',
        //     key: 'userName',
        //     align: "center"
        // },
        // {
        //     title: '公司',
        //     key: 'orgsname2',
        //     align: "center"
        // },
        // {
        //     title: '地区',
        //     key: 'orgsname4',
        //     align: "center"
        // },
        // {
        //     title: '职位',
        //     key: 'positionName',
        //     align: "center"
        // },
        // {
        //     title: '人事状态',
        //     key: 'rszt',
        //     width: 200,
        //     align: "center"
        // },

        {
          title: '详情',
          align: "center",
          slot: "slot1",
          // minWidth:60
          minWidth:100
        },
      ],
      dataTable: [],
      dataList: [],
      dataListName: [],
      loading:false,
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let obj = {
        empCode:this.searchItem.empCode,
        chName:this.searchItem.cName,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        dirFlg:'1'
      }
      // this.modal_loading=true
      // axios.post("/empInfo/employeeSearch", obj).then((res) => {
      //     this.modal_loading=false
      //     if(res){
      //         this.dataTable=res.data
      //         this.totalNum=Number(res.pageInfo.total)
      //     } 
      // })
      this.modal_loading = true
      this.dataTable.splice(0, this.dataTable.length)
      this.columns1=[]
      axios.post("/userListRole/selectUserListColumnSetData", obj).then((res) => {
        this.modal_loading = false
        if (res) {
          this.dataListName = res.tableName
          this.dataList = res.tableData.data.data
          this.totalNum = Number(res.tableData.data.pageInfo.total)

          let this_ = this
          for (var i in this_.dataListName) {
            var chName = this_.dataListName[i].chName
            var showKey = this_.dataListName[i].showKey
            this.columns1.push({
              ...this_.dataListName[i],
              title: chName,
              key: showKey,
              align: "center",
              minWidth:1440/(this_.dataListName.length)
            })
          }
          this.columns1.push(this_.columns2[0])
          this.columns1.forEach(item => {
            if(item.columnType==1){
              item.render=(h, params) => {
                for(var key in params.row){
                    if(key==item.showKey){
                      return h(
                        "span",
                        this.date.dateVal( params.row[key], "YYYY-MM-DD")
                      );
                    }
                }
              }
            }
          })
          
          for (var j in this_.dataList) {
            this.dataTable.unshift(this_.dataList[j])
          }
          
        }
      })
    },
    openPop (i, row) {
      this.$router.push({ path: '/95CAAAF222E7A036748785D9561E7187/A3FFBEBFDB713E27', query: { plan: row.serialnumber } })
    },
    pageChange (val) {
      this.pageInfo.pageNo = val
      this.getData()
    },
    async download () {
      this.loading = true
      let obj = {
        empCode:this.searchItem.empCode,
        chName:this.searchItem.cName,
        pageNo: 1,
        pageSize: 9999999
      }
      let arr=[]
      await axios.post("/userListRole/selectUserListColumnSetData", obj).then((res) => {
        if (res) {
          res.tableData.data.data.forEach(el => {
            arr.push({serialnumber:el.serialnumber})
          })
        }
      })
      
      await axios({
        url: '/empInfo/eportEmpExcel',
        method: 'post',
        data: arr,
        responseType: 'blob'
      }).then(res => {
        var A = this.$store.getters.pageData.axiosHeader['content-disposition'].split('filename=')[1]
        var FileSaver = require('file-saver')
        FileSaver.saveAs(new Blob([res]), decodeURIComponent(A))
        this.loading = false
      })
      // axios.post("/empInfo/eportEmpExcel",arr).then((res) => {
      //     var A = this.$store.getters.pageData.axiosHeader['content-disposition'].split('fileaame=')[1]
      //     console.log(A)
      //     // var A = '员工档案'
      //     var FileSaver = require('file-saver')
      //     FileSaver.saveAs(new Blob([res]), decodeURIComponent(A)+'.xls')
      // })
    }
  }
}
</script>

<style lang="scss">
.ivu-modal-body {
  max-height: calc(100vh - 200px - 51px);
  overflow-y: auto;
}
.Page-style{
  margin-top: 10px;
  display: flex;
  justify-content: flex;
  margin-bottom:-10px
}
.Page-style-end{
  float: right;
  margin-top: -20px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/EmployeeFiles.vue